import { BUBBLES } from './Data'
import '../App.css'

export default function Hero({ navigate }) {
  return (
    <section className="hero">
      {BUBBLES.map((b, i) => (
        <div
          key={i}
          className="hero-bubble"
          style={{
            width: b.w,
            height: b.w,
            left: b.l,
            top: b.t,
            animationDelay: b.d,
          }}
        />
      ))}

      <div style={{ position: 'relative', zIndex: 1 }}>
        <h1 className="hero-title">
          Dive Into <br />
          <span>Excellence.</span>
        </h1>

        <p className="hero-sub">
          World-class pools, expert coaching, and a community that pushes you
          further.
        </p>

        <div className="hero-btns">
          {/* <button className="btn-white" onClick={() => navigate('/register')}>
            Register As User
          </button>

          <button
            className="btn-ghost"
            onClick={() => navigate('/member-login')}
          >
            User Login
          </button> */}

          <button
            className="btn-ghost d-lg-none"
            type="primary"
            onClick={() => navigate('/admin-login')}
          >
            Admin Login
          </button>

        </div>

      </div>
    </section>
  )
}
